import React, { useCallback, useState } from "react";
import { buildUri, EMPTY_OBJECT, FilterMetadataApiWithCountReturn, ROUTE, ROUTE_TITLE, tracker } from "../misc";
import { DynamicPage } from "./DynamicPage";
import { SearchPageContext } from "../Context";
import { SearchParams } from "../ProviderFilter";
import { SearchResult } from "../ProviderList";
import { fetchProvidersByFilters } from "../misc";
import _ from "lodash";
import { useAsync, useStateWithUnmount } from "../hooks";

const SEARCH_PAGE_ID = "dp_search_providers";
const LSearchPage = () => {
    const [searchParams, _setSearchParams] = useState<SearchParams>(undefined);
    const [searchResult, _setSearchResult] = useState<SearchResult>({
        error: undefined,
        loading: true,
        result: undefined
    });
    const [metadataWithCount, _setMetadataWithCount] = useState<FilterMetadataApiWithCountReturn>(undefined);

    const setSearchParams = useStateWithUnmount(_setSearchParams);
    const setSearchResult = useStateWithUnmount(_setSearchResult);
    const setMetadataWithCount = useStateWithUnmount(_setMetadataWithCount);

    const load = useCallback(
        async (signal?: AbortSignal): Promise<SearchResult> => {
            // & {
            //     isLatest: boolean;
            // }
            if (!metadataWithCount || !searchParams || !_.keys(searchParams).length) return;

            // console.log(metadataWithCount, searchParams);
            let error = undefined;
            let loading = true;
            let result = undefined;

            setSearchResult((searchResult: SearchResult) => {
                const { result: _result } = searchResult ?? (EMPTY_OBJECT as SearchResult);
                return {
                    error,
                    loading,
                    result: _result
                };
            });

            // let isLatest = false;

            // cancel previous requests
            // fetchProvidersRef.current?.abort?.abort();

            // track current promise, and abort signal
            // const abortController = new AbortController();

            const providersPromise = fetchProvidersByFilters(metadataWithCount, searchParams, {
                // signal: abortController.signal
                signal
            });
            // fetchProvidersRef.current.promise = providersPromise;
            // fetchProvidersRef.current.abort = abortController;

            try {
                const providers = await providersPromise;
                // isLatest = fetchProvidersRef.current.promise === providersPromise;

                result = providers;
            } catch (err) {
                error = err;
            } finally {
                loading = false;
            }

            // isLatest &&
            //     setSearchResult({
            //         error,
            //         loading,
            //         result
            //     });

            return {
                // isLatest,
                error,
                loading,
                result
            };
        },
        [searchParams, metadataWithCount, setSearchResult]
    );

    // useEffect(() => {
    //     // fetch results
    //     const load = async () => {
    //         if (!metadataWithCount || !searchParams || !_.keys(searchParams).length) return;

    //         let error = undefined;
    //         let loading = true;
    //         let result = undefined;

    //         setSearchResult(({ result: _result }) => {
    //             return {
    //                 error,
    //                 loading,
    //                 result: _result
    //             };
    //         });

    //         let isLatest = false;

    //         // cancel previous requests
    //         fetchProvidersRef.current?.abort?.abort();

    //         // track current promise, and abort signal
    //         const abortController = new AbortController();

    //         const providersPromise = fetchProvidersByFilters(metadataWithCount, searchParams, {
    //             signal: abortController.signal
    //         });
    //         fetchProvidersRef.current.promise = providersPromise;
    //         fetchProvidersRef.current.abort = abortController;

    //         try {
    //             const providers = await providersPromise;
    //             isLatest = fetchProvidersRef.current.promise === providersPromise;

    //             result = providers;
    //         } catch (err) {
    //             error = err;
    //         } finally {
    //             loading = false;
    //         }

    //         isLatest &&
    //             setSearchResult({
    //                 error,
    //                 loading,
    //                 result
    //             });
    //     };

    //     load();
    // }, [searchParams, metadataWithCount]);

    const onLoadSuccess = useCallback(
        (
            data: SearchResult
            // & {
            //     isLatest: boolean;
            // }
        ) => {
            // data?.isLatest &&
            setSearchResult({
                error: data?.error,
                loading: data?.loading,
                result: data?.result
            });
        },
        [setSearchResult]
    );

    useAsync(load, onLoadSuccess);

    return (
        <SearchPageContext.Provider
            value={{
                searchResult,
                setSearchResult,
                searchParams,
                setSearchParams,
                metadataWithCount,
                setMetadataWithCount
            }}
        >
            <DynamicPage adminId={SEARCH_PAGE_ID} />
        </SearchPageContext.Provider>
    );
};

export const SearchPage: React.FC<{}> = () => {
    document.title = ROUTE_TITLE.SEARCH_PAGE;
    tracker.providerPageNavHistoryIndex = buildUri(ROUTE.SEARCH_PAGE);
    return <LSearchPage />;
};
